import { NAV_LINKS, COMPANY } from "./data";
import { useScrollTo } from "./primitives";
import { Mail, MapPin, Globe } from "lucide-react";

export const Footer = () => {
  const scrollTo = useScrollTo();
  return (
    <footer data-testid="footer" className="bg-slate-900 text-slate-400">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="inline-flex rounded-xl bg-white px-3 py-2">
              <img
                src="/pipemitra-logo.png"
                alt="PipeMitra"
                className="h-8 w-auto"
              />
            </div>
            <p className="mt-5 font-heading text-base font-semibold text-white">
              {COMPANY.name}
            </p>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-slate-400">
              India&rsquo;s Smart Pipeline Design Platform for Farmers.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
              Navigate
            </p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-sm text-slate-400 transition-colors hover:text-white"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
              Contact
            </p>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#5aa72f]" />
                <span>{COMPANY.location}</span>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="flex items-start gap-3 transition-colors hover:text-white"
                >
                  <Mail className="mt-0.5 h-4 w-4 shrink-0 text-[#5aa72f]" />
                  <span>{COMPANY.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Globe className="mt-0.5 h-4 w-4 shrink-0 text-[#5aa72f]" />
                <span>{COMPANY.website}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-6 border-t border-slate-800 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-slate-500">
            &copy; 2026 {COMPANY.name}. All Rights Reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <button
              data-testid="footer-privacy-link"
              className="text-xs text-slate-400 transition-colors hover:text-white"
            >
              Privacy Policy
            </button>
            <button
              data-testid="footer-terms-link"
              className="text-xs text-slate-400 transition-colors hover:text-white"
            >
              Terms &amp; Conditions
            </button>
            <button
              data-testid="footer-contact-link"
              onClick={() => scrollTo("contact")}
              className="text-xs text-slate-400 transition-colors hover:text-white"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
